module.exports = __webpack_public_path__ + "img/caigou1.afb1e2ac.png";